import React, { Component }      from 'react';
import PropTypes from 'prop-types';
import urlHandler                           from '../../utils/urlHandler';
import FinchButton                          from '../demo/FinchButton';
import _                                  from 'underscore';
import GoogleAnalytics, {categories, actions} from '../../utils/googleAnalytics';

class KbQueryControl extends Component {
    constructor(props){
        super(props);

        this.onChangeKb = this.onChangeKb.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onClear = this.onClear.bind(this);

        this.state = {
            kb: this.props.kbs ? this.props.kbs[0].name : null,
            inactive: true,
            processing: false,
            type: 'byId',
            error: null,
        }
    }

    componentDidMount() {
        if (this.refs.query && this.refs.query.getInputDOMNode) {
            this.refs.query.getInputDOMNode().focus(); 
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.permissions, this.props.permissions)) {
            this.setState({
                type: nextProps.permissions.search ? 'byName' : 'byId'
            })
        }
        if (!this.state.kb && nextProps.kbs) {
            this.setState({
                kb: nextProps.kbs[0].name
            })
        }
    }

    onChangeKb() {
        this.setState({
            kb: this.refs.kbField.value
        },() => {
            if (this.refs.query) {
                this.refs.query.focus(); 
            }
        });
    }

    onSearch() {
        var name = this.state.type === 'byName' ? this.refs.query.value : null;
        var id = this.state.type === 'byId' ? this.refs.query.value : null;
        var kb = this.refs.kbField ? this.refs.kbField.value : null;

        this.setState({
            processing: true,
            error: null
        });

        // Google Analytics
        var ga = new GoogleAnalytics();
        ga.event(categories.KB, actions.KB_SEARCH_CLICK, JSON.stringify({ name, id, kb }));

        if (kb === 'GEO') {
            var args = `query=${encodeURIComponent(this.refs.query.value)}`;
            urlHandler.sendRequest('location-finder', null, args, null, null, (response, arg1, status) => {
                if (status != 200) {
                    console.log('Error calling sendRequest => ' + JSON.stringify(response));
                    this.setState({
                        processing: false,
                        error: response.error_message
                    });
                } else {
                    if (this.props.onChange) {
                        this.props.onChange(response);
                    }
                    this.setState({
                        processing: false,
                    });
                }
            });

        } else {
            urlHandler.sendKbQueryRequest(name, id, kb, (response, status) => {
                if (status != 200) {
                    console.log('Error calling sendKbQueryRequest => ' + JSON.stringify(response));
                    this.setState({
                        processing: false,
                        error: response.error_message
                    });
                } else {
                    if (this.props.onChange) {
                        this.props.onChange(response);
                    }
                    this.setState({
                        processing: false,
                    });
                }
            });
        }
    }

    onChangeText() {
        if (this.refs.query.value && this.refs.query.value.trim().length > 0) {
            this.setState({
                inactive: false,
                error: null
            })
        } else {
            this.setState({
                inactive: true,
                error: null
            })            
        }

        if (this.props.onChange) {
            this.props.onChange([]);
        }
    }

    onClear() {
        this.setState({
            inactive: true,
            error: null
        },() => {
            this.refs.query.value = '';
            if (this.props.onChange) {
                this.props.onChange([]);
            }
            if (this.refs.query) {
                this.refs.query.focus(); 
            }
        }) 
    }

    onChangeType(e) {
        this.setState({
            type: e.target.value
        })
    }

    render() {   
        var selectedKb = this.state.kb;
        return (
            <div>
                <div>
                    <div className="kb-query-wrapper">
                        <div className='kb-query-component form-field-wrapper text-field'>
                            <input type='text'
                                className='form-field query-input-form-field'
                                name='query'
                                id='queryField'
                                ref='query'
                                placeholder='Search Query'
                                onChange={this.onChangeText}
                                autoComplete="off"
                                autoFocus
                            />
                        </div>

                        {this.state.type === 'byName' && this.props.kbs &&
                            <div className='kb-query-component form-field-wrapper text-field'>
                                <select className='form-field query-kb-form-field'
                                    name='kbField'
                                    id='kbField'
                                    ref='kbField'
                                    value={this.state.kb}
                                    onChange={this.onChangeKb}>
                                        {this.props.kbs.map((kb) => {
                                            return <option key={kb.name} value={kb.name}>{kb.name}</option>
                                        })}
                                        {this.props.permissions.locationfinder &&
                                            <option key={'GEO'} value={'GEO'}>GEO</option>
                                        }
                                </select>
                            </div>
                        }
                        
                        <FinchButton buttonClasses="kb-query-component query-button" 
                            inactive={this.state.inactive} 
                            processing={this.state.processing} 
                            primary={true} 
                            text="Search" 
                            submit={this.onSearch} />

                        <button type="button" className="clear-button" onClick={this.onClear}>Clear</button>

                        <div className="query-error">
                        {this.state.error &&
                            decodeURIComponent(this.state.error)
                        }
                        </div>

                    </div>
                    <div className="kb-query-type-wrapper">
                        {this.props.permissions.search && selectedKb !== 'GEO' &&
                            <div>
                                <input type="radio" name="searchType" 
                                    onChange={this.onChangeType} 
                                    checked={this.state.type === 'byName'} 
                                    value='byName'/>
                                <span className="m5">By Name</span>
                                <br/>
                            </div>
                        }
                        {this.props.permissions.read && selectedKb !== 'GEO' &&
                            <div>
                                <input type="radio" name="searchType" 
                                    onChange={this.onChangeType} 
                                    checked={this.state.type === 'byId'} 
                                    value='byId' /> 
                                <span className="m5">By Id</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

KbQueryControl.propTypes = {
    permissions: PropTypes.object.isRequired,
    kbs: PropTypes.array,
    onChange: PropTypes.func
};

export default KbQueryControl;
